import { render, staticRenderFns } from "./DigitacionSubTab.vue?vue&type=template&id=7b544b23&"
import script from "./DigitacionSubTab.vue?vue&type=script&lang=js&"
export * from "./DigitacionSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports